const backgroundColorPlugin = {
  id: "backgroundColorPlugin",
  beforeDraw: (chart, args, options) => {
    const { ctx, chartArea, scales } = chart;
    const yAxis = scales.y;

    const regions = options?.regions || [
      { color: "rgba(75, 192, 192, 0.2)", start: 60, end: 100 }, // Positive
      { color: "rgba(255, 205, 86, 0.2)", start: 40, end: 60 },  // Neutral
      { color: "rgba(255, 99, 132, 0.2)", start: 0, end: 40 }     // Negative
    ];

    regions.forEach(({ color, start, end }) => {
      ctx.save();
      ctx.fillStyle = color;
      const yStart = yAxis.getPixelForValue(start);
      const yEnd = yAxis.getPixelForValue(end);
      ctx.fillRect(chartArea.left, yEnd, chartArea.right - chartArea.left, yStart - yEnd);
      ctx.restore();
    });
  },
};

export default backgroundColorPlugin;
